import React from 'react';
import SidebarComponent from './SidebarComponent';
import PageHeader from './PageHeader';

const DesignAndConsultancy: React.FC = () => {
    return (
        <>
            <PageHeader title="Design & Engineering Consultancy" />

            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
                style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                <div className="container">
                    <div className="row g-5">

                        <div className="col-lg-8">
                            <div className="row g-3 mb-5">
                                <div className="col-md-6">
                                    <img className="img-fluid" src="img/commercial-1.jpg" alt="" />
                                </div>
                                <div className="col-md-6">
                                    <img className="img-fluid" src="img/commercial-2.jpg" alt="" />
                                </div>
                            </div>
                            <h1 className="mb-4">Design & Engineering Consultancy</h1>
                            <p>WTIL provides expert design and consultancy services for new water and wastewater treatment projects as well as retrofits. Our experienced engineers conduct detailed water audits, feasibility studies, and technical evaluations to propose the most effective and sustainable solutions.</p>

                            <h3 className="mb-4">Services Offered:</h3>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Conceptual & detailed engineering</p>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>P&ID, GA drawings, hydraulic profiles</p>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Process simulations and pilot trials</p>
                            <p><i className="fa fa-hand-holding-water text-primary me-2"></i>BOQ and cost estimations</p>
                        </div>

                        <div className="col-lg-4">
                            <SidebarComponent />
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default DesignAndConsultancy;
